import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SiteEnhancements } from "./components/enhancements";
import ScrollReveal from "./components/feature/ScrollReveal";
import { Analytics } from "@vercel/analytics/react";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollReveal />
        <AppRoutes />
        <SiteEnhancements
          phone="+1-954-296-4896"
          bookHref="/audit"
          accent="#0d9488"
          exitHeadline="Before you leave — see your AI visibility"
          exitBody="Check whether ChatGPT, Perplexity, Gemini, and Claude recommend your business when asked. Free scan."
          exitCtaLabel="Run my AI scan"
          exitCtaHref="/audit"
        />
        <Analytics />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
